import { modelOptions, prop } from '@typegoose/typegoose';
import * as mongoose from 'mongoose';
import { CompanyShort } from './protected-entities.model';

@modelOptions({
  schemaOptions: {
    collection: 'gzTags',
  },
  options: {
    customName: 'gzTags',
  },
})
export class GzTagsModel {
  @prop({ required: true, _id: true })
  _id: mongoose.Types.ObjectId;

  @prop({ required: true })
  name: string;

  @prop({ required: true, type: CompanyShort })
  company: CompanyShort;
}
